import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography } from '@altermaind/web/ui';
import { Charts } from '@/_shared/components/Charts';
import { useBreakingPoints } from '@/_shared/hooks/useBreakpoint';
import { getSurveyCampaignByIdResponsesResultsStatsCall } from '@/surveys/state/api';

export const DepartmentDistributionBox = () => {
  const t = useTranslations('departments.tabs.department.assessment.distributionBox');
  const { isDesktop } = useBreakingPoints();

  const { departmentsStats } = getSurveyCampaignByIdResponsesResultsStatsCall.hook();

  return (
    <Box>
      <Typography variant='h3' mb='xxxs'>
        {t('title')}
      </Typography>
      <Typography variant='p3/light' mb='l'>
        {t('description')}
      </Typography>
      <Charts.StackedBarChartComponent
        total={departmentsStats?.[0]?.totalCompletedSurveys || 0}
        data={departmentsStats?.[0]?.metricsScore || []}
        defaultItemsSize={isDesktop ? 6 : 2}
      />
    </Box>
  );
};
